import React, { createContext, useCallback, useMemo, useState, useRef } from 'react';

import { Toast } from 'primereact/toast';

export const ToasterContext = createContext(null);

export function ToasterContextProvider({ children }) {
  const toast = useRef(null);
  const [toasterPosition, setToasterPosition] = useState(null);
  const [testId, setTestId] = useState('');

  const openToaster = useCallback((position, body = {}, dataTestId = '') => {
    setToasterPosition(position);
    setTestId(dataTestId);
    toast.current.show(body);
  }, []);

  const context = useMemo(() => ({ openToaster }), [openToaster]);

  return (
    <>
      <ToasterContext.Provider value={context}>{children}</ToasterContext.Provider>
      <Toast
        data-testid={testId}
        style={{ fontSize: '23px' }}
        ref={toast}
        position={toasterPosition}
      />
    </>
  );
}
